import type {
  DateRangeTabListPresetMap,
  PeriodUnitListPresetMap,
} from './type';

export enum PERIOD_UNIT {
  MINUTE = 'minute',
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
  CUSTOM = 'custom',
}

export const PERIOD_UNIT_LIST_PRESET: PeriodUnitListPresetMap = Object.freeze({
  en: [
    { label: 'Day', value: PERIOD_UNIT.DAY },
    { label: 'Week', value: PERIOD_UNIT.WEEK },
    { label: 'Month', value: PERIOD_UNIT.MONTH },
    { label: 'Year', value: PERIOD_UNIT.YEAR },
  ],
  ko: [
    { label: '일', value: PERIOD_UNIT.DAY },
    { label: '주', value: PERIOD_UNIT.WEEK },
    { label: '개월', value: PERIOD_UNIT.MONTH },
    { label: '년', value: PERIOD_UNIT.YEAR },
  ],
  jp: [
    { label: '日', value: PERIOD_UNIT.DAY },
    { label: '週', value: PERIOD_UNIT.WEEK },
    { label: '月', value: PERIOD_UNIT.MONTH },
    { label: '年', value: PERIOD_UNIT.YEAR },
  ],
  cn: [
    { label: '日', value: PERIOD_UNIT.DAY },
    { label: '周', value: PERIOD_UNIT.WEEK },
    { label: '月', value: PERIOD_UNIT.MONTH },
    { label: '年', value: PERIOD_UNIT.YEAR },
  ],
});

export const DATE_RANGE_TAB_LIST_PRESET = Object.freeze({
  en: {
    minute: [
      {
        label: 'Recnet 24H',
        value: 24,
        unit: PERIOD_UNIT.HOUR,
      },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    hour: [
      { label: 'Recnet 24H', value: 24, unit: PERIOD_UNIT.HOUR },
      { label: 'Recnet 48H', value: 48, unit: PERIOD_UNIT.HOUR },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    day: [
      { label: 'Recnet 15D', value: 15, unit: PERIOD_UNIT.DAY },
      { label: 'Recnet 30D', value: 30, unit: PERIOD_UNIT.DAY },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    week: [
      { label: 'Recnet 4W', value: 4, unit: PERIOD_UNIT.WEEK },
      { label: 'Recnet 8W', value: 8, unit: PERIOD_UNIT.WEEK },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    month: [
      { label: 'Recnet 6M', value: 6, unit: PERIOD_UNIT.MONTH },
      { label: 'Recnet 1Y', value: 12, unit: PERIOD_UNIT.MONTH },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    year: [
      { label: 'Recnet 1Y', value: 1, unit: PERIOD_UNIT.YEAR },
      { label: 'Recnet 2Y', value: 2, unit: PERIOD_UNIT.YEAR },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
  },
  ko: {
    minute: [
      { label: '최근 24시간', value: 24, unit: PERIOD_UNIT.HOUR },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    hour: [
      { label: '최근 24시간', value: 24, unit: PERIOD_UNIT.HOUR },
      { label: '최근 48시간', value: 48, unit: PERIOD_UNIT.HOUR },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    day: [
      { label: '최근 15일', value: 15, unit: PERIOD_UNIT.DAY },
      { label: '최근 30일', value: 30, unit: PERIOD_UNIT.DAY },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    week: [
      { label: '최근 4주', value: 4, unit: PERIOD_UNIT.WEEK },
      { label: '최근 8주', value: 8, unit: PERIOD_UNIT.WEEK },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    month: [
      { label: '최근 6개월', value: 6, unit: PERIOD_UNIT.MONTH },
      { label: '최근 1년', value: 12, unit: PERIOD_UNIT.MONTH },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    year: [
      { label: '최근 1년', value: 1, unit: PERIOD_UNIT.YEAR },
      { label: '최근 2년', value: 2, unit: PERIOD_UNIT.YEAR },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
  },
  jp: {
    minute: [
      { label: '最近24時間', value: 24, unit: PERIOD_UNIT.HOUR },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    hour: [
      { label: '最近24時間', value: 24, unit: PERIOD_UNIT.HOUR },
      { label: '最近48時間', value: 48, unit: PERIOD_UNIT.HOUR },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    day: [
      { label: '最近15日', value: 15, unit: PERIOD_UNIT.DAY },
      { label: '最近30日', value: 30, unit: PERIOD_UNIT.DAY },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    week: [
      { label: '最近4週', value: 4, unit: PERIOD_UNIT.WEEK },
      { label: '最近8週', value: 8, unit: PERIOD_UNIT.WEEK },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    month: [
      { label: '最近6ヶ月', value: 6, unit: PERIOD_UNIT.MONTH },
      { label: '最近1年', value: 12, unit: PERIOD_UNIT.MONTH },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    year: [
      { label: '最近1年', value: 1, unit: PERIOD_UNIT.YEAR },
      { label: '最近2年', value: 2, unit: PERIOD_UNIT.YEAR },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
  },
  cn: {
    minute: [
      { label: '最近24小时', value: 24, unit: PERIOD_UNIT.HOUR },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    hour: [
      { label: '最近24小时', value: 24, unit: PERIOD_UNIT.HOUR },
      { label: '最近48小时', value: 48, unit: PERIOD_UNIT.HOUR },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    day: [
      { label: '最近15日', value: 15, unit: PERIOD_UNIT.DAY },
      { label: '最近30日', value: 30, unit: PERIOD_UNIT.DAY },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    week: [
      { label: '最近4周', value: 4, unit: PERIOD_UNIT.WEEK },
      { label: '最近8周', value: 8, unit: PERIOD_UNIT.WEEK },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    month: [
      { label: '最近6个月', value: 6, unit: PERIOD_UNIT.MONTH },
      { label: '最近1年', value: 12, unit: PERIOD_UNIT.MONTH },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
    year: [
      { label: '最近1年', value: 1, unit: PERIOD_UNIT.YEAR },
      { label: '最近2年', value: 2, unit: PERIOD_UNIT.YEAR },
      { label: 'custom', value: 0, unit: PERIOD_UNIT.CUSTOM },
    ],
  },
}) as DateRangeTabListPresetMap;
